import { OptimizelyFeatureFlags } from 'constants/featureFlags'
import { getOptimizelyFeatureFlagVariation, isAllowedToTriggerExperiment } from 'lib/optimizely/optimizelyUtils'
import { isSpoofed } from 'selectors/isSpoofed'

export function isMultiTicketFlightsEnabled(state: App.State): boolean {
  return !!isSpoofed(state) &&
    isAllowedToTriggerExperiment(true, state.utm.content, OptimizelyFeatureFlags.multiTicketFlights) &&
    getOptimizelyFeatureFlagVariation(state, OptimizelyFeatureFlags.multiTicketFlights)
}

export function isMultiTicketMultiCabinFlightsEnabled(state: App.State): boolean {
  return isMultiTicketFlightsEnabled(state) &&
    isAllowedToTriggerExperiment(true, state.utm.content, OptimizelyFeatureFlags.multiTicketMultiCabinFlights) &&
    getOptimizelyFeatureFlagVariation(state, OptimizelyFeatureFlags.multiTicketMultiCabinFlights)
}
